import { CookieAttributes } from 'js-cookie';

import { getIsLocalDev } from '@vestico/utils';

export const defaultCookieAttributes = (): CookieAttributes => {
  const isLocalDev = getIsLocalDev();
  return {
    secure: !isLocalDev,
  };
};
